<template>
  <div id="app">
    <self-header v-if="$route.meta.noHeader != true" />
    <div class="app-content">
      <router-view />
    </div>
    <self-footer v-if="$route.meta.noFooter != true" />
  </div>
</template>
<script>
import SelfHeader from "./components/SelfHeader.vue";
import SelfFooter from "./components/SelfFooter.vue";
export default {
  components: { SelfHeader, SelfFooter },
  mounted() {},
};
</script>
<style lang="less">
#app {
  width: 100%;
  .app-content {
    width: 100%;
    min-height: 400px;
    background-color: #f5f7fa;
  }
}
</style>

<style>
.v-modal {
  z-index: 2000 !important;
}
</style>
